import { TabType } from "./CarCardTabs";
import { CarCardsInfoTab } from "./tabs/CardCardInfoTab";
import { MessageHistory } from "./MessageHistory";
import { VehicleCardDocuments } from "./VehicleCardDocuments";
import VehicleCardImages from "./VehicleCardImages";
import { VehicleCardDetails } from "@/types/vehicleCard";
import { useLanguage } from "@/context/LanguageContext";

interface CarCardTabContentProps {
  activeTab: TabType;
  vehicleCard: VehicleCardDetails;
}

export const CarCardTabContent = ({
  activeTab,
  vehicleCard,
}: CarCardTabContentProps) => {
  const { language } = useLanguage();

  switch (activeTab) {
    case "info":
      return <CarCardsInfoTab key={language} vehicleCard={vehicleCard} />;
    case "documents":
      return (
        <VehicleCardDocuments
          key={language}
          regNumber={vehicleCard.vehicleDetails?.regNumber}
          vehicleTests={vehicleCard.vehicleTests || []}
          payment={vehicleCard.payment}
          owner_change={vehicleCard.documents?.owner_change || []}
          other_documents={vehicleCard.documents?.other_documents || []}
          vehicleCardId={vehicleCard.id}
        />
      );
    case "images": {
      const vehicleImages = vehicleCard?.images;
      return (
        <VehicleCardImages
          key={`images-${vehicleCard.id}-${language}`}
          images={vehicleImages}
          vehicleCardId={vehicleCard.id}
        />
      );
    }
    case "history":
      return (
        <MessageHistory
          key={language}
          carCardId={vehicleCard.id}
          events={vehicleCard.history || []}
          vehicleName={`${vehicleCard.vehicleDetails?.make ?? ""} ${vehicleCard.vehicleDetails?.model ?? ""}`.trim()}
          regNumber={vehicleCard.vehicleDetails?.regNumber}
        />
      );
    default:
      return <CarCardsInfoTab vehicleCard={vehicleCard} />;
  }
};
